import React from 'react';
import DeviceList from './deviceList';
import {
    Card,
    CardBody,
    Col,
    Row,
    CardTitle,
    FormGroup,
    Form
  } from "reactstrap"
  
  import { connect } from "react-redux";
  
  //Import Action to copy breadcrumb items from local state to redux state
  import { setBreadcrumbItems } from "../../store/actions";
  import { useEffect } from 'react';
  import { useState } from 'react';
  import Select from "react-select"
import { AvForm, AvField } from "availity-reactstrap-validation";
import SweetAlert from "react-bootstrap-sweetalert";
import { apiEndpoint } from "helpers/url_helper";



function FirmwareConfig(props) {

const [SelectedCampusValue, setSelectedCampusValue] = useState(1);
const [toggleSwitch, settoggleSwitch] = useState(true)
const [toggleSwitchSize, settoggleSwitchSize] = useState(true)
const [SpeedLimit, setSpeedLimit] = useState('');
const [GreenDisplayMsg, setGreenDisplayMsg] = useState('');
const [AmberDisplayMsg, setAmberDisplayMsg] = useState();
const [RedDisplayMsg, setRedDisplayMsg] = useState();
const [LightThreshold, setLightThreshold] = useState();
const [CampsuList, setCampusList] = useState([]);
const [LocationList, setLocationList] = useState([]);
const [SelectedLocationValue, setSelectedLocationValue] = useState(1);
const [ FirmwareDetails, setFirmwareDetails] = useState(['']);
const [ AddMessageResponse, setAddMessageResponse] = useState('');
const [ AddMessageResponseType, setAddMessageResponseType] = useState('');


const [basic, setbasic] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);


    
 
  
  useEffect(() => {
  debugger;
  // UserValidated
  fetch(apiEndpoint+"/CampusList",
  {
    mode: "cors",
   method:"POST",
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      "strToken": sessionStorage.getItem("Clear_AuthUser")
      
    })
})
.then(res => res.json())
.then((data) => {
 debugger;
    setCampusList(data.CampusList);
    
    GetLocationList(data.CampusList[0].CampusID);
    //sessionStorage.setItem("authUser",JSON.stringify(data.strNewToken))
});

},[]);

const handleCampusChange = event => {
  debugger;
 
 
  setSelectedCampusValue(event.target.value);
  GetLocationList(event.target.value);


  
};

const handleLocationChange = event => {
  debugger;

  
 
  setSelectedLocationValue(event.target.value);
  
  GetFirmwareList(event.target.value);
  
 


  
};


const GetFirmwareList = (LocationId) => {
 
  debugger;
  
  var intLocationID = LocationId;
  // UserValidated
  fetch(apiEndpoint+"/GetFirmwareDetails",
  {
   method:"POST",
    headers: {
      'Content-Type': 'application/json',
     // 'Access-Control-Allow-Origin': '*',
    },
    body: JSON.stringify({
      "intLocationID": intLocationID,
      "strToken": sessionStorage.getItem("Clear_AuthUser")
    })
})
.then(res => res.json())
.then((data) => {
 debugger;
 
 if(data.FirmwareDetails.SpeedLimit != null){
  setFirmwareDetails(data.FirmwareDetails);
  setSpeedLimit(data.FirmwareDetails.SpeedLimit);
  setGreenDisplayMsg(data.FirmwareDetails.GreenDisplayMessage);
  setAmberDisplayMsg(data.FirmwareDetails.AmberDisplayMessage);
  setRedDisplayMsg(data.FirmwareDetails.RedDisplayMessage);


  
 
 }
 else{
  setSpeedLimit('');
  setGreenDisplayMsg('');
  setAmberDisplayMsg('');
  setRedDisplayMsg(''); 
  console.log(SpeedLimit);
  setFirmwareDetails();
 }
   
});

};


const GetLocationList = (CampusID) => {
  debugger;
  
  var intCampusID = CampusID;
  // UserValidated
  fetch(apiEndpoint+"/SelectedLocationList",
  {
    method:"POST",
    headers: {
      'Content-Type': 'application/json',
      //'Access-Control-Allow-Origin': '*',
    },
    body: JSON.stringify({
      "intCampusID": intCampusID,
      "strToken": sessionStorage.getItem("Clear_AuthUser")
    })
})
.then(res => res.json())
.then((data) => {
 debugger;
 console.log("Locaton List",data);
 if(data.LocationDetails != null)
 {
  setLocationList(data.LocationDetails);
  GetFirmwareList(data.LocationDetails[0].LocationID);
  setSelectedLocationValue(data.LocationDetails[0].LocationID);
 }
 else{
  setGreenDisplayMsg('');
  setRedDisplayMsg('');
  setAmberDisplayMsg('');
  setSpeedLimit('');
  setLocationList([
    {"LocationID" : 0,
      "LocationName": ""}
  ]);
 }

   
});

};

const SubmitNewFirmwareDetails = () => {
  
  debugger;
  // UserValidated
  fetch(apiEndpoint+'/AddNewFirmwareDetails',
    {
      mode: "cors",
      method: "POST",
      headers: {
        'Content-Type': 'application/json',
      //  'Access-Control-Allow-Origin': '*',
      },
      body: JSON.stringify({
        "intCampusID": SelectedCampusValue,
        "intLocationID": SelectedLocationValue,
        "strGreenMessage": GreenDisplayMsg,
        "strAmberMessage": AmberDisplayMsg,
        "strRedMessage": RedDisplayMsg,
        "strSpeedLimit": SpeedLimit,
        "strToken": sessionStorage.getItem("Clear_AuthUser")
      })


    }
  )
  .then(res => res.json())
  .then((data) => {
    setAddMessageResponse(data.ResponseMessage);
    setAddMessageResponseType(data.ResponseType)
    if (data.ResponseType != "error") {

      debugger;
      setbasic(true);
      setModalOpen(false);

    }
    else {
      setbasic(true);
    }
  });
}

function isValidSpeedLimit(value){
  const Regex = /^([1-9]|[1-9][0-9]|1[0-9][0-9])$/;
  if(!Regex.test(value))
  {
    return "Invalid Speed Limit"
  }
  return true;
}

   
      return (
        <React.Fragment>
    

    {basic ? (
        <SweetAlert
          title={AddMessageResponse}
           type={AddMessageResponseType}
          onConfirm={() => {
            setbasic(false)
          }}
        />
      ) : null}
          <Row>
         
            <Col className="col-md-12">
              <Card>
                <CardBody>
              
                  <Row className="mb-3">
                    <label
                      htmlFor="example-text-input"
                      className="col-md-2 col-form-label"
                    >
                      Campus
                        </label>  
                    <div className="col-md-4">

                       <select className="form-control" value={SelectedCampusValue} onChange={handleCampusChange} classNamePrefix="select2-selection"
                    >
                       { CampsuList.map(i => <option value={i.CampusID}>{i.CampusName}</option>
                         )}
                         
                        </select>
                    </div>
                  </Row>
                  <Row className="mb-3">
                    <label
                      htmlFor="example-text-input"
                      className="col-md-2 col-form-label"
                    >
                      Location
                        </label>
                    <div className="col-md-4" >
                    <select className="form-control" value={SelectedLocationValue} onChange={handleLocationChange} >
                       { LocationList.map(i => <option value={i.LocationID}>{i.LocationName}</option>
                         )}
                        </select>
                      
                    </div>
                  </Row>
                  <AvForm onValidSubmit ={SubmitNewFirmwareDetails}
                  > 
                  <Row className="mb-3">
                    <label
                      htmlFor="example-email-input"
                      className="col-md-2 col-form-label"
                    >
                      Speed Limit
                        </label>
                    <div className="col-md-4">
                      <AvField
                        className="form-control"
                        name="Speed Limit"                                               
                        placeholder="Speed Limit"
                        type="number"
                        validate={{ custom: isValidSpeedLimit }}

                        value={SpeedLimit}
                      
                        onChange={(event) => {
                          setSpeedLimit(event.target.value);
                          
                        }}
                      />
                    </div>
                  </Row>
                  <Row className="mb-3">
                    <label
                      htmlFor="example-email-input"
                      className="col-md-2 col-form-label"
                    >
                      Green Display Message 
                        </label>
                    <div className="col-md-4">
                      <AvField
                       className="mb-3"
                       name="Green Display Message"                        
                       placeholder="Green Display Message"
                       type="text"
                       errorMessage="This text field is required"
                       validate={{
                         required: { value: true },
                         minLength: { value: 6, errorMessage: "Min 6 chars." },
                       }}
                       value={GreenDisplayMsg}
                        onChange={(event) => {
                          setGreenDisplayMsg(event.target.value);
                          console.log(GreenDisplayMsg);
                        }}
                       
                      />
                    </div>
                  </Row>
                 
                  <Row className="mb-3">
                    <label
                      htmlFor="example-email-input"
                      className="col-md-2 col-form-label"
                    >
                      Amber Display Messgae 
                        </label>
                    <div className="col-md-4">
                    <AvField
                        className="mb-3"
                        name="Amber Display Message"                        
                        placeholder="Amber Display Message"
                        type="text"
                        errorMessage="This text field is required"
                        validate={{
                          required: { value: true },
                          minLength: { value: 6, errorMessage: "Min 6 chars." },
                        }}
                        value={AmberDisplayMsg}
                        onChange={(event) => {
                          setAmberDisplayMsg(event.target.value);
                        }}
                      />
                    </div>
                  </Row>
                  <Row className="mb-3">
                    <label
                      htmlFor="example-email-input"
                      className="col-md-2 col-form-label"
                    >
                      Red Display Messgae 
                        </label>
                    <div className="col-md-4">
                    <AvField
                       className="mb-3"
                       name="Red Display Message"                        
                       placeholder="Red Display Message"
                       type="text"
                       errorMessage="This text field is required"
                       validate={{
                         required: { value: true },
                         minLength: { value: 6, errorMessage: "Min 6 chars." },
                       }}
                       value={RedDisplayMsg}
                        onChange={(event) => {
                          setRedDisplayMsg(event.target.value);
                        }}
                      />
                    </div>
                  </Row>
                  <Row>
                 
                  <div className="col-md-6 offset-2">
                            <button type="submit" className="btn btn-primary w-md" >Submit</button>
                          </div>
                  </Row>
                 </AvForm>
                </CardBody>
              </Card>
            </Col>
          </Row>
         
         
    
       
    
         
    
        </React.Fragment>
      )
}


export default FirmwareConfig;